import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=e189a8b0&scoped=true&"
import script from "./Warranty.vue?vue&type=script&lang=js&"
export * from "./Warranty.vue?vue&type=script&lang=js&"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=e189a8b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e189a8b0",
  null
  
)

export default component.exports